var render = function render() {
  var _vm$styleObj;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticStyle: {
      position: "relative"
    },
    style: {
      "--color": _vm.themeColor
    },
    on: {
      click: function ($event) {
        return _vm.$emit("itemClick");
      }
    }
  }, [_c("div", {
    staticClass: "invoiceList"
  }, [_c("div", {
    staticClass: "queryInfo"
  }, [_c("a-select", {
    staticStyle: {
      width: "160px"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("产品")
    }
  }), _vm._l((_vm$styleObj = _vm.styleObj) === null || _vm$styleObj === void 0 || (_vm$styleObj = _vm$styleObj.buttonInfo) === null || _vm$styleObj === void 0 ? void 0 : _vm$styleObj.buttons, function (item, index) {
    return _c("span", {
      staticClass: "button",
      style: {
        background: item.buttonBgColor,
        color: item.buttonFontColor
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(item.buttonName)) + " ")]);
  })], 2), _c("div", {
    staticClass: "top"
  }, [_c("a-radio", [_vm._v(_vm._s(_vm.$t("单次开票选择上限XXX个")))]), _c("span", [_vm._v(_vm._s(_vm.$t("累计选择保单数量")) + "： "), _c("b", [_vm._v("xxx")]), _vm._v(" " + _vm._s(_vm.$t("个")) + " ")])], 1), _c("div", {
    staticClass: "list"
  }, [_c("div", {
    staticClass: "cardItem"
  }, [_c("a-radio"), _c("div", {
    staticClass: "cont"
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v("xxx" + _vm._s(_vm.$t("保险")))]), _c("div", {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.$t("被保人")) + "：    xxx")]), _c("div", {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.$t("保费")) + "：        xxx")]), _c("div", {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.$t("保险状态")) + "： xxx")]), _c("div", {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.$t("保障时间")) + "： xxx")]), _c("div", {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.$t("保单号")) + "：     xxx")]), _c("div", {
    staticClass: "status"
  }, [_vm._v(_vm._s(_vm.$t("发票状态")))])])], 1), _c("div", {
    staticClass: "cardItem"
  }, [_c("a-radio"), _c("div", {
    staticClass: "cont"
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v("xxx" + _vm._s(_vm.$t("保险")))]), _c("div", {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.$t("被保人")) + "：    xxx")]), _c("div", {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.$t("保费")) + "：        xxx")]), _c("div", {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.$t("保险状态")) + "： xxx")]), _c("div", {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.$t("保障时间")) + "： xxx")]), _c("div", {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.$t("保单号")) + "：     xxx")]), _c("div", {
    staticClass: "status"
  }, [_vm._v(_vm._s(_vm.$t("发票状态")))])])], 1)])]), _c("div", [_vm._t("edit")], 2)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };